import * as React from 'react';
import SocialMediaIcons from 'components/SocialMediaIcons/index';
import { SocialMediaGroupIconsContainer } from './SocialMediaGroup.styles';
import type { SocialMediaGroupProps } from './SocialMediaGroup.types';

const SocialMediaGroup = ({ icons, className }: SocialMediaGroupProps): React.ReactElement<any> => (
  <SocialMediaGroupIconsContainer className={className}>
    {icons?.length
      ? icons.map((item: any) => <SocialMediaIcons icon={item.name} url={item.url} />)
      : null}
  </SocialMediaGroupIconsContainer>
);

export default SocialMediaGroup;
